<template>
  <div>
    <resource-type-field :value="resourceType"
                         :disabled="false"
                         :fieldNameAddition="entityId"
                         @input="onResourceTypeChange" />

    <services-with-hubs-filter :available-hubs="availableHubs"
                               :availableServices="availableServices"
                               :disabledConditions="false"
                               :dataUser="userEntity"
                               :isManager="false"
                               :isInternal="needsAffiliatedService"
                               @change="onChange($event.field, $event.value)" />

    <occupations-field :fieldNameAddition="entityId"
                       :user="userEntity"
                       :availableOccupations="availableOccupations"
                       @change="onOccupationsChange" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResourceTypeField from '@/components/users/form/ResourceTypeField'
import ServicesWithHubsFilter from '@/components/users/form/ServicesWithHubsFilter'
import OccupationsField from '@/components/users/form/OccupationsField'
import _ from 'lodash'

export default {
  name: 'CandidateEntityForm',
  components: {
    ResourceTypeField,
    ServicesWithHubsFilter,
    OccupationsField
  },
  inject: ['$validator'],
  props: ['userEntity', 'manageableOptions'],
  data() {
    return {
      selectedServices: [],
      selectedAffiliatedService: null
    }
  },
  computed: {
    ...mapGetters({
      manageableServices: 'users/manageableServices',
      manageableOccupations: 'users/manageableOccupations',
      manageableHubs: 'users/manageableHubs'
    }),
    availableServices() {
      return this.manageableOptions ? this.manageableOptions.all_services : this.manageableServices
    },
    availableHubs() {
      return this.manageableOptions ? this.manageableOptions.all_hubs : this.manageableHubs
    },
    availableOccupations() {
      return this.manageableOptions ? this.manageableOptions.occupations : this.manageableOccupations
    },
    entityId() {
      return this.userEntity.entity.id;
    },
    resourceType() {
      return this.userEntity.resource_type;
    },
    needsAffiliatedService() {
      return this.resourceType == 'intern';
    },
  },
  methods: {
    emitChange(field, value) {
      this.$emit('change', { entityId: this.entityId, field: field, data: value });
    },
    onChange(fieldName, value) {
      if(fieldName == 'affiliated_service') {
        this.onAffiliatedServiceChange(value)
      } else if(fieldName == 'services') {
        this.onServicesChange(value)
      }
    },
    onResourceTypeChange(value) {
      this.emitChange('resource_type', value);
    },
    onAffiliatedServiceChange(value) {
      this.selectedAffiliatedService = value;
      this.emitChange('affiliated_service', value);
    },
    onServicesChange(value) {
      this.selectedServices = value;
      this.emitChange('services', value);
    },
    onOccupationsChange(value) {
      this.emitChange('occupations', value);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/entities/CandidateEntityForm.vue